import { OrderItemDataFragment, Enum_Orderitemaction_Action } from "data";
import { ReflowIcon } from "components/Icons";
import {
  ActionComponent,
  ActionComponentVariant,
} from "components/ActionComponent";
import { useRegisterOrderItemAction } from "features/order-items/data/hooks/order-item-actions";

interface ReflowActionProps {
  orderItem: OrderItemDataFragment;
  variant: ActionComponentVariant;
}

export const ReflowAction = (props: ReflowActionProps) => {
  const { orderItem, variant } = props;
  const { registerAction } = useRegisterOrderItemAction();
  return (
    <ActionComponent
      action={async () => {
        if (orderItem.id) {
          await registerAction({
            orderItem,
            action: {
              action: Enum_Orderitemaction_Action.Reflow,
            },
          });
        }
      }}
      variant={variant}
      actionIcon={<ReflowIcon />}
      actionLabel="Reflow"
      data-cy="action-reflow"
    />
  );
};

ReflowAction.defaultProps = {
  variant: "menu-item",
};
